import apis from ".";

export const LoginAdmin = async (Username, Password) => {
    try {
        const response = await apis.post("/login-admin", {
            Username: Username,
            Password: Password
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
};

//User - Admin
export const getAllUsers = async (token, page = 1, perPage = 50) => {
  try {
    const result = await apis.get(
      `/user/get-all-users?page=${page}&perPage=${perPage}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const disableUser = async (userId, token) => {
  try {
    const result = await apis.post("/user/disable-user", null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const enableUser = async (userId, token) => {
  try {
    const result = await apis.post("/user/enable-user", null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

//Seller - Admin
export const getAllSellers = async (token, page = 1, perPage = 50) => {
  try {
    const result = await apis.get(
      `/seller/get-all-sellers?page=${page}&perPage=${perPage}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const disableSeller = async (sellerId, token) => {
  try {
    const result = await apis.post("/seller/disable-seller", null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const enableSeller = async (sellerId, token) => {
  try {
    const result = await apis.post("/seller/enable-seller", null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

//Product - Admin
export const getAllProducts = async (token, page = 1, perPage = 50) => {
  try {
    const result = await apis.get(
      `/product/get-all-products?page=${page}&perPage=${perPage}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const disableProduct = async (productId, token) => {
  try {
    const result = await apis.post("/user/disable-product", null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const enableProduct = async (productId, token) => {
  try {
    const result = await apis.post("/user/enable-product", null, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export async function getHomeCategories(token) {
  try {
    const result = await apis.get(
      `/category/get-all-categories?page=1&perPage=10`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

// Create a new category
export const createCategory = async (formData, accessToken) => {
  try {
    const result = await apis.post("/product/add-category", formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};